import Button from "app/components/button/button";
import CircleLoader from "app/components/loader/CircleLoader";
import { TGLink } from "app/config";
import useAppNavigation from "app/hooks/useAppNavigate";
import InfoIcon from "assets/img/icons/iIcon.svg";
import Karma from "assets/img/icons/karma.svg";
import { FC } from "react";
import { useAccount } from "wagmi";
import styles from "./account-widget.module.scss";
import WalletWidget from "./wallet-widget/wallet-widget";

enum ETier {
  ALPHA = "Alpha",
  BETA = "Beta",
  GAMMA = "Gamma",
  BEGINNER = "Beginner",
}

enum ETierTitle {
  ALPHA = "Top 5%",
  BETA = "81%-94%",
  GAMMA = "41%-80%",
  BEGINNER = "Lower 40%",
  UNKNOWN = "Unknown rank",
}

interface AccountWidgetProps {
  balance?: number;
  karma?: number;
  tier?: string;
  karmaLoading: boolean;
  tierLoading: boolean;
  balanceLoading: boolean;
}

const AccountWidget: FC<AccountWidgetProps> = ({
  balance,
  karma,
  tier,
  karmaLoading,
  tierLoading,
  balanceLoading,
}) => {
  const { address } = useAccount();
  const { navigateToLink } = useAppNavigation();

  const getTitle = (tier: string): string => {
    switch (tier) {
      case ETier.ALPHA:
        return ETierTitle.ALPHA;
      case ETier.BETA:
        return ETierTitle.BETA;
      case ETier.GAMMA:
        return ETierTitle.GAMMA;
      case ETier.BEGINNER:
        return ETierTitle.BEGINNER;
      default:
        return ETierTitle.UNKNOWN;
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.accountWidget}>
        <div className={styles.accountContainer}>
          <div className={styles.titleContainer}>
            <h1 className={styles.title}>Connected Wallet</h1>
          </div>
          <WalletWidget />
          <p className={styles.text}>
            Your Karma Balance & Tier information is updated every 24 hours
          </p>
        </div>
        <div className={styles.tgBtnWrapper}>
          <Button onClick={navigateToLink(`${TGLink}${address}`)}>
            Join AlphaMind Telegram bot
          </Button>
          <p>Receive instance notifications & important IDO updates</p>
        </div>
      </div>
      <div className={styles.tierContainer}>
        <div className={styles.tierWrapper}>
          <p className={styles.tierTitle}>Karma Balance</p>
          {karmaLoading ? (
            <span>
              <CircleLoader isLoading={karmaLoading} />
            </span>
          ) : (
            <h3 className={styles.tier}>{Math.floor(karma || 0)} KARMA</h3>
          )}
        </div>
        <div className={styles.tierWrapper}>
          <p className={styles.tierTitle}>$MIND Balance</p>
          {balanceLoading ? (
            <span>
              <CircleLoader isLoading={balanceLoading} />
            </span>
          ) : (
            <h3 className={styles.tier}>
              {balance}{" "}
              <img className={styles.mindIcon} src={Karma} alt="MIND logo" />{" "}
              $MIND
            </h3>
          )}
        </div>
      </div>
      <div className={styles.tierContainer}>
        <div className={styles.tierWrapper}>
          <div className={styles.tierTitle}>
            My Tier
            <div className={styles.tooltip}>
              <img src={InfoIcon} alt="info" className={styles.infoIcon} />
              <span className={styles.tooltipText}>
                AlphaMind Tiers are dynamic and assigned based on your position
                in the Karma leaderboard. The information is updated every 24
                hours and your Tier may change depending on the performance of
                others in comparison to your activity.
              </span>
            </div>
          </div>
          {tierLoading ? (
            <span>
              <CircleLoader isLoading={tierLoading} />
            </span>
          ) : (
            <h3 className={styles.tier}>{tier || "Unranked"}</h3>
          )}
          {/* <Button
						size='S'
						className={styles.btn}
						variant='outlined'>
							How to increase my Tier
						</Button> */}
        </div>
        <div className={styles.tierWrapper}>
          <p className={styles.tierTitle}>My Position</p>
          {tierLoading || typeof tier === undefined ? (
            <span>
              <CircleLoader isLoading={tierLoading} />
            </span>
          ) : tier !== undefined ? (
            <h3 className={styles.tier}>{getTitle(tier)}</h3>
          ) : (
            <h3 className={styles.tier}>Unranked</h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccountWidget;
